import React from 'react';
import styled from 'styled-components';

import Section from './global/section';

const LaptopStyle = styled.div`
	.flex {
		display: flex;
		.logo {
			width: 35%;
			display: flex;
			align-items: center;
			img {
				width: 100%;
			}
		}
		.text {
			width: 30%;
			margin-left: 5%;
			display: flex;
			align-items: center;
			a {
				color: ${(p) => p.theme.color.green};
				position: relative;
				span {
					position: relative;
					left: 0;
					transition: 0.3s left;
				}
				&:hover span {
					left: 0.5rem;
				}
			}
		}
		.laptop {
			width: 30%;
			position: relative;
			img {
				position: absolute;
				top: -1rem;
				width: 100%;
			}
		}
	}
	@media all and (max-width: 868px) {
		section {
			padding: 4rem 0;
		}
	}
	@media all and (max-width: 768px) {
		.flex {
			flex-direction: column;
			.logo {
				width: 100%;
				img {
					max-width: 400px;
				}
			}
			.text {
				width: 100%;
				margin-left: 0;
				margin-top: 2rem;
			}
			.laptop {
				width: 100%;
				margin-bottom: -9rem;
				img {
					position: relative;
					top: 0;
				}
			}
		}
	}
	@media all and (max-width: 500px) {
		.flex .laptop {
			margin-bottom: -7rem;
		}
	}
`;

export default ({ img }) => {
	return (
		<LaptopStyle>
			<Section bg="white">
				<div className="flex">
					<div className="logo">
						<img src="/img/CMHALogo2.svg" alt="cmha logo" />
					</div>
					<div className="text">
						<p>
							For complete resources and more info about Mental Health Services
							in Simcoe County and beyond, go to{' '}
							<a
								target="_blank"
								rel="noopener noreferrer"
								href="https://cmhastarttalking.ca/"
							>
								cmhastarttalking.ca <span>></span>
							</a>
						</p>
					</div>
					<div className="laptop">
						<img src={img} alt="person with laptop" />
					</div>
				</div>
			</Section>
		</LaptopStyle>
	);
};
